import TableView from "../components/TableView";
import React, {useEffect, useState} from "react";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {useOutletContext} from "react-router-dom";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {InputTextarea} from "primereact/inputtextarea";
import {DepartmentService} from "../services/DepartmentService";

function DepartmentGroup() {

    const context = useOutletContext()

    const [loading, setLoading] = useState(true)
    const [dialogVisible, setDialogVisible] = useState(false)

    const [groups, setGroups] = useState([])
    const [classes, setClasses] = useState([])

    const tableRows = [
        {label: 'Название', name: 'name', selected: true}
    ];

    useEffect(() => {
        context.setActiveTab('groups')
        setGroups(context.groups.filter((el) => el.type === 'kindergarten_group'))
        setClasses(context.groups.filter((el) => el.type === 'school'))
        setLoading(false)
    }, [context]);

    const handleEditItem = (e) => {

    }


    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-pencil',
            command: (e) => {

                additionalForm.setValues([...groups, ...classes].find((el) => el.id === e.item.rowId))
                setDialogVisible(true)
                // navigation('/departments/' + e.item.rowId)
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить эту группу?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {
                        setLoading(true)
                        DepartmentService.deleteGroup(e.item.rowId).then(() => {
                            context.updateData()
                        })
                    },
                    acceptLabel: 'Да',
                    reject: () => {
                        return false
                    },
                    rejectLabel: 'Нет'
                });
            }
        }
    ];

    const handlerRawActions = (elId) => {

        const currentRow = [...classes, ...groups].find((el) => {
            return el.id === elId
        })


        if(currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId
            })
            return rowActions;
        }
    }

    const addAdditionalHandler = (type) => {
        additionalForm.resetForm()
        additionalForm.setFieldValue('type', type, false)
        setDialogVisible(true)
    }

    const additionalForm = useFormik({
        initialValues: {
            name: ''
        },
        validate: (data) => {
            let errors = {}

            if(!data.name){
                errors.name = 'Укажите название'
            }


            return errors
        },
        onSubmit: (data) => {
            setLoading(true)
            data.department_id = context.id

            if(data.id) {
                DepartmentService.updateGroup(data).then((result) => {
                    context.updateData()
                    setDialogVisible(false)
                })
            } else {
                DepartmentService.addGroup(data).then((result) => {
                    context.updateData()
                    setDialogVisible(false)
                })
            }
        }
    })

    return (
        <>

            <ConfirmDialog/>
            <Dialog header={'Добавление/редактирование группу'} style={{width: '400px'}} onHide={() => setDialogVisible(false)} visible={dialogVisible}>
                <form className={'edit-department'} onSubmit={additionalForm.handleSubmit}>
                    <FormGroup label={'Наименование'} error={additionalForm.errors.name}>
                        <InputText value={additionalForm.values.name} onChange={(e) => additionalForm.setFieldValue('name', e.target.value)} autoFocus/>
                    </FormGroup>



                    <Button loading={loading} type={'submit'} label={'Сохранить'}/>
                </form>
            </Dialog>


            <div className="row">
                <div className="col-lg-5">
                    <div className="card project-list">
                        <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between m-b-30">
                                <h3 className={''}>Группа </h3>
                                <Button icon={'pi pi-plus'} label={'Добавить'} className={'p-button-sm p-button-success'} onClick={(e) => addAdditionalHandler('kindergarten_group')}/>
                            </div>
                            <TableView id={'groups-list'} tableRows={tableRows} data={{items: groups}}
                                       loading={loading}
                                       setTableRows={(data) => setGroups(data)} handleEdit={handleEditItem}
                                       rowActions={rowActions} massRowActions={false} massActionHander={false}
                                       rowActionsHandler={handlerRawActions} tableClass={'departments-table'}
                                       hideHead={true} hideSettings={true}/>

                        </div>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="card project-list">
                        <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between m-b-30">
                                <h3 className={''}>Классы </h3>
                                <Button icon={'pi pi-plus'} label={'Добавить'} className={'p-button-sm p-button-success'}  onClick={(e) => addAdditionalHandler('school')}/>
                            </div>
                            <TableView id={'additional-list'} tableRows={tableRows} data={{items: classes}}
                                       loading={loading}
                                       setTableRows={(data) => setClasses(data)} handleEdit={handleEditItem}
                                       rowActions={rowActions} massRowActions={false} massActionHander={false}
                                       rowActionsHandler={handlerRawActions} tableClass={'departments-table'}
                                       hideSettings={true} hideHead={true}/>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}

export default DepartmentGroup